

const APC_DESKTOP_BREAKPOINT = 1024;
let lastDesktopLayoutSignature = '';

// add margin top if hero media text section is not first section
function updateMainOffset() {
    const main = document.querySelector("main");
    if (!main) return;
  
    const firstSection = main.querySelector(".shopify-section");
    const hero = main.querySelector(".hero-media-text-section");
  
    if (!hero || hero.closest(".shopify-section") !== firstSection) {
      main.style.marginTop =
        "calc(var(--header-height) + var(--notification-bar-height))";
    } else {
      main.style.marginTop = "";
    }
  }
  
  document.addEventListener("load", updateMainOffset);
  document.addEventListener("shopify:section:load", updateMainOffset);
  document.addEventListener("shopify:section:unload", updateMainOffset);
  document.addEventListener("shopify:section:reorder", updateMainOffset);
  window.addEventListener("load", updateMainOffset);
  
  /**
   * Wrap multiple elements inside a wrapper (safe to rerun)
   */
  function wrapElementsInSection(section, selector, wrapperClass) {
    if (!section) return;
  
    const elements = Array.from(section.querySelectorAll(selector));
    if (!elements.length) return;
  
    // Remove existing wrapper safely
    const oldWrapper = section.querySelector(`.${wrapperClass}`);
    if (oldWrapper) {
      while (oldWrapper.firstChild) {
        oldWrapper.parentNode.insertBefore(oldWrapper.firstChild, oldWrapper);
      }
      oldWrapper.remove();
    }
  
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;
  
    elements[0].parentNode.insertBefore(wrapper, elements[0]);
    elements.forEach(el => wrapper.appendChild(el));
  }
  
  /**
   * Wrap multiple selectors into a single section wrapper
   */
  function wrapIntoSectionInSection(section, selectors, sectionClass) {
    if (!section) return;
  
    const elements = selectors.flatMap(sel =>
      Array.from(section.querySelectorAll(sel))
    );
  
    if (!elements.length) return;
  
    const classSelector = sectionClass.replace(/\s+/g, '.');
    const oldSection = section.querySelector(`.${classSelector}`);
  
    if (oldSection) {
      while (oldSection.firstChild) {
        oldSection.parentNode.insertBefore(oldSection.firstChild, oldSection);
      }
      oldSection.remove();
    }
  
    const newSection = document.createElement('div');
    newSection.className = sectionClass;
  
    elements[0].parentNode.insertBefore(newSection, elements[0]);
    elements.forEach(el => newSection.appendChild(el));
  }
  
  /**
   * Wrap right-column content in order: jump first, editor-order middle, contact last
   */
  function wrapRightContentOrdered(section, wrapperClass) {
    if (!section) return;

    // Collect all right-content elements, excluding the mobile contact block
    const all = Array.from(
      section.querySelectorAll('.article-page-right-content:not(.apc-contact-mobile)')
    );
    if (!all.length) return;

    // Remove existing wrapper safely
    const oldWrapper = section.querySelector(`.${wrapperClass}`);
    if (oldWrapper) {
      while (oldWrapper.firstChild) {
        oldWrapper.parentNode.insertBefore(oldWrapper.firstChild, oldWrapper);
      }
      oldWrapper.remove();
    }

    // Sort: jump → middle (DOM/editor order) → contact
    const jumpEls    = all.filter(el => el.classList.contains('apc-jump'));
    const contactEls = all.filter(el => el.classList.contains('apc-contact'));
    const middleEls  = all.filter(el => !jumpEls.includes(el) && !contactEls.includes(el));

    const ordered = [...jumpEls, ...middleEls, ...contactEls];
    if (!ordered.length) return;

    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;

    all[0].parentNode.insertBefore(wrapper, all[0]);
    ordered.forEach(el => wrapper.appendChild(el));
  }

  /**
   * Remove ALL instances of a wrapper class from the document,
   * moving children back to their parent before removing.
   */
  function removeAllWrappers(wrapperClass) {
    const classSelector = wrapperClass.replace(/\s+/g, '.');
    document.querySelectorAll(`.${classSelector}`).forEach(wrapper => {
      while (wrapper.firstChild) {
        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
      }
      wrapper.remove();
    });
  }

  function getDesktopLayoutSignature(section) {
    const selectors = [
      '.apc-article-title',
      '.apc-social-icons',
      '.article-section-center-part',
      '.article-page-right-content:not(.apc-contact-mobile)'
    ];

    return selectors
      .map((selector) => {
        const nodes = Array.from(section.querySelectorAll(selector));
        const parts = nodes.map((node) => {
          const parentClass = node.parentElement?.className || '';
          return `${node.className}|${parentClass}`;
        });
        return `${selector}:${parts.join('>')}`;
      })
      .join('||');
  }

  function getArticleScope(section = document) {
    return (
      section.querySelector('.article-page-controls') ||
      document.querySelector('.article-page-controls') ||
      section
    );
  }

  function getArticleObserverTarget() {
    const articleScope = getArticleScope(document);
    if (!articleScope || articleScope === document) return null;
    return articleScope.closest('.shopify-section') || articleScope;
  }

  function isArticleSectionEvent(event) {
    const sectionId = event?.detail?.sectionId;
    if (!sectionId) return true;

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (section) {
      return !!section.querySelector(
        '.article-page-controls, .apc-article-title, .article-page-right-content, .article-section-center-part'
      );
    }

    return !!document.querySelector(
      `.section-${sectionId}.article-page-controls, .section-${sectionId} .article-page-controls, .section-${sectionId}.apc-article-title, .section-${sectionId} .apc-article-title`
    );
  }

  /**
   * Initialize article layout inside a section
   */
  function initArticleLayout(section) {
    if (!section) return;

    // ✅ Run on 1024px and above
    if (window.innerWidth < APC_DESKTOP_BREAKPOINT) {
      lastDesktopLayoutSignature = '';
      return;
    }

    const articleScope = getArticleScope(section);
    const beforeSignature = getDesktopLayoutSignature(articleScope);
    if (beforeSignature && beforeSignature === lastDesktopLayoutSignature) return;

    // Tear down all stale wrappers from any previous run before rebuilding.
    // Order matters: outermost first so children are freed before inner ones are removed.
    removeAllWrappers('article-page__main-section');
    removeAllWrappers('article-page__main-content page-width');
    removeAllWrappers('article-page__right-wrapper');
    removeAllWrappers('article-page__center-wrapper');
  
    wrapElementsInSection(
      section,
      '.article-section-center-part',
      'article-page__center-wrapper'
    );
  
    wrapRightContentOrdered(section, 'article-page__right-wrapper');
  
    wrapIntoSectionInSection(
      section,
      [
        '.apc-social-icons',
        '.article-page__center-wrapper',
        '.article-page__right-wrapper'
      ],
      'article-page__main-content page-width'
    );
  
    wrapIntoSectionInSection(
      section,
      [
        '.apc-article-title',
        '.article-page__main-content'
      ],
      'article-page__main-section'
    );
    
    articleScope.querySelectorAll('product-card').forEach(card => {
      card?.initializeSwiper();
      card?.updateSwiper();
    });

    lastDesktopLayoutSignature = getDesktopLayoutSignature(articleScope);
  }

  const scheduleInitArticleLayout = (() => {
    let rafId = null;
    return () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        initArticleLayout(document);
      });
    };
  })();
  
  /**
   * Initial load
   */
  document.addEventListener('DOMContentLoaded', () => {
    initArticleLayout(document);
  });

  /**
   * Shopify Theme Editor events
   */

  // section:load = full HTML replacement. Remove stale moved elements first,
  // then rewrap. Without this, moved elements from the old section persist
  // alongside the fresh ones, duplicating content on every setting change.
  document.addEventListener('shopify:section:load', (event) => {
    if (!isArticleSectionEvent(event)) return;

    if (event?.detail?.sectionId) {
      const sectionId = event.detail.sectionId;
      const freshSection = document.querySelector(`[data-section-id="${sectionId}"]`);
      document.querySelectorAll(`.section-${sectionId}`).forEach(el => {
        if (!freshSection || !freshSection.contains(el)) {
          el.remove();
        }
      });
    }
    scheduleInitArticleLayout();
  });

  // All other editor events: just rewrap, no stale cleanup needed.
  [
    'shopify:section:reorder',
    'shopify:section:select',
    'shopify:section:unload'
  ].forEach(evt => {
    document.addEventListener(evt, (event) => {
      if (!isArticleSectionEvent(event)) return;
      scheduleInitArticleLayout();
    });
  });
  
  /**
   * Theme Editor: re-run when settings change (no save needed)
   * Some setting changes update DOM without reliably firing editor events.
   */
  if (window.Shopify && Shopify.designMode) {
    let articleLayoutObserver = null;
  
    const reconnectArticleLayoutObserver = () => {
      if (!articleLayoutObserver) return;
      const observerTarget = getArticleObserverTarget();
      if (!observerTarget) return;

      articleLayoutObserver.observe(observerTarget, {
        childList: true,
        subtree: true,
      });
    };
  
    const runArticleLayoutSafely = () => {
      // Prevent infinite loops: our wrappers mutate DOM too.
      if (articleLayoutObserver) articleLayoutObserver.disconnect();
      scheduleInitArticleLayout();
      // Reconnect after DOM settles a bit.
      setTimeout(reconnectArticleLayoutObserver, 50);
    };
  
    const scheduleArticleLayout = debounce(runArticleLayoutSafely, 150);
  
    articleLayoutObserver = new MutationObserver((mutations) => {
      // Observer is already scoped to article area; only check meaningful child changes.
      const relevant = mutations.some((m) => {
        if (m.type !== 'childList') return false;
        return (m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length);
      });
      if (relevant) scheduleArticleLayout();
    });
  
    // Start observing once DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        reconnectArticleLayoutObserver();
        scheduleArticleLayout();
      });
    } else {
      reconnectArticleLayoutObserver();
      scheduleArticleLayout();
    }
  }
  
  /**
   * Handle resize across 1024px breakpoint
   */
  let lastWidth = window.innerWidth;
  
  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;
  
    // Only rerun when crossing the breakpoint
    if (
      (lastWidth < APC_DESKTOP_BREAKPOINT && currentWidth >= APC_DESKTOP_BREAKPOINT) ||
      (lastWidth >= APC_DESKTOP_BREAKPOINT && currentWidth < APC_DESKTOP_BREAKPOINT)
    ) {
      initArticleLayout(document);
    }
  
    lastWidth = currentWidth;
  });
  
  
  const scheduleMoveSectionsToMain = (() => {
    let rafId = null;
    return () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        moveSectionsToMain();
      });
    };
  })();
  
  function moveSectionsToMain() {
    const articleMainSection = document.querySelector('.article-page-controls');
    if (window.innerWidth < APC_DESKTOP_BREAKPOINT && articleMainSection) {
      const dateEl = document.querySelector('.article-date-section');
      const authorInfoEl = document.querySelector('.article-author-info-section');

      const thirdEl = document.querySelector('.article-date-extra-section');

      let dateAuthorWrapper = document.querySelector('.apc-date-author-wrapper');
      if (!dateAuthorWrapper && (dateEl || authorInfoEl || thirdEl)) {
        dateAuthorWrapper = document.createElement('div');
        dateAuthorWrapper.className = 'apc-date-author-wrapper';
      }
      if (dateAuthorWrapper) {
        if (dateEl) dateAuthorWrapper.appendChild(dateEl);
        if (authorInfoEl) dateAuthorWrapper.appendChild(authorInfoEl);
        if (thirdEl) dateAuthorWrapper.appendChild(thirdEl);

        // Count total visual columns: each top-level section = 1, except
        // article-author-info-section whose internal wrappers each count as 1
        let totalCols = 0;
        if (dateEl) totalCols++;
        if (thirdEl) totalCols++;
        let authorWrapperCount = 0;
        if (authorInfoEl) {
          authorWrapperCount = authorInfoEl.querySelectorAll('.article-author-section-wrapper').length;
          totalCols += authorWrapperCount || 1;
        }

        dateAuthorWrapper.style.gridTemplateColumns = `repeat(${totalCols}, 1fr)`;
        if (authorInfoEl && authorWrapperCount > 1) {
          authorInfoEl.style.gridColumn = `span ${authorWrapperCount}`;
        }
      }

      const orderedElements = [
        dateAuthorWrapper,
        document.querySelector('.apc-jump-list-mobile'),
        ...document.querySelectorAll('.article-section-center-part--mobile'),
        document.querySelector('.apc-social-icons'),
        document.querySelector('.apc-contact-mobile ')
      ];

      const existingElements = orderedElements.filter(Boolean);
      let alreadyOrdered = true;
      let lastChildIndex = -1;
      existingElements.forEach((el) => {
        const childIndex = Array.prototype.indexOf.call(articleMainSection.children, el);
        if (el.parentNode !== articleMainSection || childIndex <= lastChildIndex) {
          alreadyOrdered = false;
        }
        lastChildIndex = childIndex;
      });

      if (!alreadyOrdered) {
        orderedElements.forEach(el => {
          if (el) {
            articleMainSection.appendChild(el);
          }
        });
        document.querySelectorAll('product-card').forEach(card => {
            card.initializeSwiper();
            card.updateSwiper();
        });
      }
    }
  }
  
  // Run once
  moveSectionsToMain();
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      scheduleMoveSectionsToMain();
    }, 150);
  });
  
  /* -----------------------------------
    Shopify Theme Editor hooks
  ----------------------------------- */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (!isArticleSectionEvent(event)) return;
      scheduleMoveSectionsToMain();
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!isArticleSectionEvent(event)) return;
      scheduleMoveSectionsToMain();
    });
    document.addEventListener('shopify:section:select', (event) => {
      if (!isArticleSectionEvent(event)) return;
      scheduleMoveSectionsToMain();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (!isArticleSectionEvent(event)) return;
      scheduleMoveSectionsToMain();
    });
  }
  
  function trackElementHeight(selector, cssVarName) {
    const el = document.querySelector(selector);
    if (!el) return;
  
    const updateHeight = () => {
      document.documentElement.style.setProperty(cssVarName, `${el.offsetHeight}px`);
    };
  
    // Initial set
    updateHeight();
  
    // Observe size changes
    const observer = new ResizeObserver(updateHeight);
    observer.observe(el);
  
    // Update on window resize as a fallback
    window.addEventListener('resize', updateHeight);
  }
  
  // Usage
  trackElementHeight('.article-author-section.article-section-center-part', '--author-section-height');
  trackElementHeight('.apc-contact', '--apc-contact-height');

  // Jump-link smart scroll:
  // - target below visible area → scroll to top (0 offset)
  // - target above or partially above visible area → scroll with 122px header gap
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.apc-jump-link');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    // Extract hash from href (handles both '#id' and '/path#id')
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    const hash = href.slice(hashIndex).slice(1); // remove '#'

    // If href has a path that differs from current page, let browser navigate normally
    const path = href.slice(0, hashIndex);
    if (path && path !== window.location.pathname) return;

    const target = document.querySelector(`[data-target="${hash}"]`);
    if (!target) return;


    e.preventDefault();

    const accordion = link.closest('accordion-animated');

    const doScroll = () => {
      const headerEl = document.querySelector('sticky-header');
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const notifHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--notification-bar-height')) || 0;
      const accordionEl = document.querySelector('accordion-animated.apc-jump-list-mobile');
      const accordionHeight = accordionEl ? accordionEl.offsetHeight : 0;
      const rect = target.getBoundingClientRect();
      const absoluteTop = window.pageYOffset + rect.top;
      const isScrollingUp = rect.top < 0;
      const offset = isScrollingUp ? headerHeight + notifHeight + accordionHeight : accordionHeight;
      const scrollTop = Math.max(0, absoluteTop - offset);
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
      history.pushState(null, '', `#${hash}`);
    };

    if (accordion) {
      accordion.close();
      const anim = accordion.animation;
      if (anim) {
        anim.addEventListener('finish', doScroll, { once: true });
      } else {
        setTimeout(doScroll, 300);
      }
    } else {
      doScroll();
    }
  });
